var map = {
  "./catppuccin.json": "456699",
  "./dracula.json": "920465",
  "./github.json": "284638",
  "./gruvbox.json": "636224",
  "./material.json": "807968",
  "./monokai.json": "551969",
  "./nord.json": "765812",
  "./one-dark.json": "928918",
  "./rose-pine.json": "213175",
  "./solarized.json": "12268",
  "./tokyo-night.json": "629014"
};


function __rspack_context(req) {
  var id = __rspack_context_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context.keys = function webpackContextKeys() {
  return Object.keys(map);
};
__rspack_context.resolve = __rspack_context_resolve;
module.exports = __rspack_context;
__rspack_context.id = 304624;
